<!-- <p>festival-offer works!</p>
<div *ngFor="let pack of filterdPackage">
    <p>{{pack?.name}}</p>

    <li *ngFor="let comp of pack?.packageSubscriptionDto?.componentsList">
        {{comp?.displayName}}
    </li>
    <a (click)="BuyNow()">BuyNow</a>
</div>

<div>
    <li>
        <a class="nav-item nav-link" 
        (click)="subjectChanged(sub)" *ngFor="let sub of gradeData?.subjects">{{ sub.subName }}</a>
    </li>
    <ul>
        <li *ngFor="
            let syllabus of selectedSubject?.syllabus;
            let i = index
          " class="syllabuslist">
          {{ syllabus.topic }}
        </li>
      </ul>
</div>

<a (click)="Submit()">Submit</a> -->
<app-new-header></app-new-header>
  <div class="neetJeepage">
    
    <section class="festhero-area prodetailbg">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-lg-12 col-12" *ngFor="let pack of filterdPackage">
                    <div class="productDetailsSection">
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-12">
                                    <div class="fes_leftcont" *ngIf="!microCourses">
                                        <h1 class="detailhd"> {{pack?.name}}</h1>
                                        <div *ngFor="let comp of pack?.packageSubscriptionDto?.componentsList;let i=index">
                                          <h6 class="detailsubhd" *ngIf="i<3">. {{comp?.displayName}}</h6>
                                        </div>
                                        <div *ngIf="pack?.productId == 3">
                                          <h6 class="detailsubhd">1 Month Subscription Only</h6>
                                        </div>                                     
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'">₹ 999 <span class="fes_crdisline">₹ 3999</span>
                                            <span class="fes_croff">( 75% OFF )</span></h4>
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 6 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 7">₹ 399 <span class="fes_crdisline">₹ 1299</span>
                                            <span class="fes_croff">( 73% OFF )</span></h4>
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 8">₹ 699 <span class="fes_crdisline">₹ 2499</span>
                                            <span class="fes_croff">( 73% OFF )</span></h4>
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 9 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 10">₹ 799 <span class="fes_crdisline">₹ 2999</span>
                                            <span class="fes_croff">( 73% OFF )</span></h4>        
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 11 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 12">₹ 899 <span class="fes_crdisline">₹ 3299</span>
                                            <span class="fes_croff">( 73% OFF )</span></h4>
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 1">₹ {{pack?.packageSubscriptionDto?.amount}} <span class="fes_crdisline">₹ {{pack?.packageSubscriptionDto?.amountPreDiscount}}</span>
                                            <span class="fes_croff">( {{pack?.packageSubscriptionDto?.displayDiscountPercentage}}% OFF )</span></h4>
                                        <h4 class="fes_cprice pricemb" *ngIf="pack?.productId == 6">₹ 249 <span class="fes_crdisline">₹ 1699</span>
                                            <span class="fes_croff">( 85% OFF )</span></h4>  
                                    </div>
                                    <div class="fes_leftcont" *ngIf="microCourses">
                                      <h1 class="detailhd"> {{pack?.name}}</h1>
                                      <div *ngFor="let comp of pack?.packageSubscriptionDto?.componentsList;let i=index">
                                        <h6 class="detailsubhd" *ngIf="i<3">. {{comp?.displayName}}</h6>
                                      </div>
                                   
                                      <!-- <h4 class="fes_cprice pricemb">₹ {{microMobAmount}}<span class="fes_crdisline"></span>
                                          <span class="fes_croff"></span></h4>  -->
                                  </div>
                                </div>
                            </div>

                            <div class="row rowmr_38">
                                <div class="col-md-12 col-lg-12 col-12">
                                    <!-- <figure class="mb-0">
                                        <img src="/assets/img/festival/classfest.png" alt="classfest" class="classfest">
                                    </figure> -->
                                  <iframe class="hmvideo" style="max-width:100% !important" width="760" height="415"
                                    src="https://www.youtube.com/embed/B9nrI7dazkQ" title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                                </div>
                            </div>
                            
                            <div class="purchaseSection purchasemob">
                              <div class="row">
                                  <div class="col-md-12 col-lg-12 col-12" *ngFor="let pack of filterdPackage">
                                      <div class="fes_rightcont">
                                          <h5 class="fest_cpack">Choose your {{pack?.productName}}</h5>
                                          <div class="festgrdebox" *ngIf="!microCourses">
                                              <div class="packtitle">
                                                  <h6 class="fest_chpktitle">{{pack?.name}}</h6>
                                                      <h4 *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'"  class="fest_chpdisprce">(75% off)</h4>
                                                      <h4 *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE'" class="fest_chpdisprce">(73% off)</h4>
                                                      <h4 *ngIf="pack?.productId == 1" class="fest_chpdisprce">({{pack?.packageSubscriptionDto?.displayDiscountPercentage}}% off)</h4>
                                                      <h4 *ngIf="pack?.productId == 6" class="fest_chpdisprce">(85% off)</h4>
                                              </div>
                                              <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'">
                                                  <h5 class="fespack_cdprice">₹ 999</h5>
                                                  <p class="fespack_dsprice">₹ 3999</p>
                                              </div>
                                              <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE'  && selectedGrade == 6 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 7">
                                                <h5 class="fespack_cdprice">₹ 399</h5>
                                                <p class="fespack_dsprice">₹ 1299</p>
                                            </div>
                                              <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 8">
                                                <h5 class="fespack_cdprice">₹ 699</h5>
                                                <p class="fespack_dsprice">₹ 2499</p>
                                            </div>
                                            <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 9 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 10">
                                              <h5 class="fespack_cdprice">₹ 799</h5>
                                              <p class="fespack_dsprice">₹ 2999</p>
                                            </div>
                                            <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 11 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 12">
                                              <h5 class="fespack_cdprice">₹ 899</h5>
                                              <p class="fespack_dsprice">₹ 3299</p>
                                            </div>
                                              <div class="packprice" *ngIf="pack?.productId == 1">
                                                <h5 class="fespack_cdprice">₹ {{pack?.packageSubscriptionDto?.amount}}</h5>
                                                <p class="fespack_dsprice">₹ {{pack?.packageSubscriptionDto?.amountPreDiscount}}</p>
                                              </div>
                                              <div class="packprice" *ngIf="pack?.productId == 6">
                                              <h5 class="fespack_cdprice">₹ 249</h5>
                                              <p class="fespack_dsprice">₹ 1699</p>
                                              </div>
                                          </div>
                                          <div class="plan-duration-list-area" *ngIf="microCourses">
                                            <!-- <h4 class="selct-duration-text" *ngIf="subscriptionbillingUtility?.packageValidityList?.length">Select a
                                              duration</h4> -->
                                            <div class="mduration-list-box">
                                              <ul class="mduration-list">
                                
                                                <li *ngFor="let package of  subscriptionbillingUtility.packageValidityList;let index = index">
                                                  <label class="mduration-radio-box">                                              
                                                    <input type="checkbox" name="subscription_duration" [value]="package?.numOfMonths"

                                                      [checked]="package?.numOfMonths == selectedMonths">
                                                    <div class="mradio-chk-box" (click)="selectPackage(package)"></div>
                                                    <div class="mcontent-wrap" (click)="selectPackage(package)">
                                                      <div class="mlft-pnl">
                                                        <div class="mmonth-title-area">
                                                          <h4>{{packageDeatails?.name}}</h4>
                                                          <h3>{{package?.numOfMonths}} Month<span *ngIf="package?.numOfMonths >1">s</span> Validity
                                                          </h3>
                                                          <!-- <h4>Valid till {{package?.validDate | date :'d MMM, y'}}</h4> -->
                                                        </div>
                                                      </div>
                                                      <div class="mprice-pnl">
                                                        <div class="mpricrow">
                                                          <img src="assets/img/rupee-black-icon.svg" alt="" />
                                                          <div class="mprice">{{package?.amount| number:'1.0-0'}}</div>
                                                        </div>
                                                        <!-- <div class="total-in" *ngIf="(package?.amount/package?.numOfMonths)!=package?.amount"><span
                                                            class="rupee">₹</span> {{package?.amount}} in Total</div> -->
                                                      </div>
                                                    </div>
                                                  </label>
                                                </li>
                                              </ul>                                         
                                            </div>
                                          </div>
                                          <!-- <button type="button" class="fest_buypackbtn"(click)="BuyNow()">Buy Package</button> -->
                                          <div class="sharefiled">
                                            <h5 class="share_or">OR</h5>
                                            <h6 class="share_ask">Ask parents to buy now</h6>
                                            <div>
                                                <div class="number_field">
                                                    <input type="tel" class="number_input" value="{{sharedLink}}" id="cpycpn" #cpycpn  placeholder="">
                                                    <button type="button" *ngIf="!linkCopid" (click)="copycoupon(cpycpn)" class="copy_btn"><b>Copy</b></button>
                                                    <button type="button" *ngIf="linkCopid" (click)="copycoupon(cpycpn)" class="copy_btn"><b>Copied</b></button>
                                                </div>
                                            </div>
                                            <h6 class="share_ask">Share this page via</h6>
                                            <figure>
                                                <a href="https://api.whatsapp.com/send?phone=&text={{encodedUrl}}" data-action="share/whatsapp/share" class="festshremr"><img src="/assets/img/festival/festwhatsapp.png" alt="whatsapp" class="shareimg"></a>
                                                <span ><a (click)="copycoupon(cpycpn)"><img src="/assets/img/festival/festmsg.png" alt="msg" class="shareimg"></a></span>
                                            </figure>
                                        </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                            <div class="row rowmr_38">
                                <div class="col-md-12 col-lg-12 col-12">
                                    <div class="fest_features">
                                        <h4 class="festfea_hd">Features</h4>
                                        <div>
                                            <div>
                                                <div class="festfea_flex">
                                                    <div class="package_option">
                                                      <ul class="jeecollist">
                                                          <li *ngFor="let comp of pack?.packageSubscriptionDto?.componentsList"> <img src="/assets/img/festival/featick.png" class="">{{comp?.displayName}}</li>
                                                      </ul>
                                                  </div>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row rowmr_38">
                                <div class="col-md-12 col-lg-12 col-12">
                                    <div class="fest_features">
                                        <h4 class="festfea_hd">Syllabus</h4>
                                        <div>
                                            <ul class="nav nav-tabs justify-content-center sloffer_grades" id="myTab" role="tablist">
                                                <li class="nav-item" role="presentation" *ngFor="let sub of gradeData?.subjects">
                                                    <a class="nav-link slgrjee" [ngClass]="{active: selectedSubject.subName == sub?.subName}" 
                                                    id="slgrneet14-tab" data-toggle="tab" href="#slgrjee" role="tab" aria-controls="neet"
                                                    aria-selected="false" (click)="subjectChanged(sub)"><span><img src="{{sub?.imageUrl}}" class="sesssub-icon" alt=""></span> {{ sub?.subName }}</a>
                                                </li>
                                                <!-- <li class="nav-item" role="presentation">
                                                    <a class="nav-link slgrjee12 " id="slgrneet12-tab" data-toggle="tab" href="#slgrjee12" role="tab" aria-controls="jee"
                                                        aria-selected="true"><span><img src="/assets/img/festival/physics.png" alt=""></span> Physics</a>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <a class="nav-link slgrjee13" id="slgrneet13-tab" data-toggle="tab" href="#slgrjee13" role="tab"
                                                        aria-controls="jee" aria-selected="true"><span><img src="/assets/img/festival/botany.png" alt=""></span> Botany</a>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <a class="nav-link slgrjee14" id="slgrneet13-tab" data-toggle="tab" href="#slgrjee14" role="tab"
                                                        aria-controls="jee" aria-selected="true"><span><img src="/assets/img/festival/zoology.png" alt=""></span> Zoology</a>
                                                </li> -->
                                            </ul>
        
                                            <div class="tab-content" id="myTabContent">
                                                <div role="tabpanel" class="tab-pane fade show active" id="slgrjee">
                                                    <div class="row">
                                                        <div class="col-md-12 col-lg-12 col-12">
                                                            <div>
                                                                <div>
                                                                    <ul class="festsub_list">
                                                                    <li *ngFor="let syllabus of selectedSubject?.syllabus;let i = index">
                                                                    {{ syllabus.topic }}
                                                                    </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="purchaseSection purchaseweb">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-12" *ngFor="let pack of filterdPackage">
                                    <div class="fes_rightcont">
                                        <h5 class="fest_cpack">Choose your {{pack?.productName}}</h5>
                                        <div class="festgrdebox" *ngIf="!microCourses">
                                            <div class="packtitle">
                                                <h6 class="fest_chpktitle">{{pack?.name}}</h6>
                                                    <h4 *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'"  class="fest_chpdisprce">(75% off)</h4>
                                                    <h4 *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE'" class="fest_chpdisprce">(73% off)</h4>
                                                    <h4 *ngIf="pack?.productId == 1" class="fest_chpdisprce">({{pack?.packageSubscriptionDto?.displayDiscountPercentage}}% off)</h4>
                                                    <h4 *ngIf="pack?.productId == 6" class="fest_chpdisprce">(85% off)</h4>
                                            </div>
                                            <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'">
                                                <h5 class="fespack_cdprice">₹ 999</h5>
                                                <p class="fespack_dsprice">₹ 3999</p>
                                            </div>
                                            <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE'  && selectedGrade == 6 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 7">
                                              <h5 class="fespack_cdprice">₹ 399</h5>
                                              <p class="fespack_dsprice">₹ 1299</p>
                                          </div>
                                            <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 8">
                                              <h5 class="fespack_cdprice">₹ 699</h5>
                                              <p class="fespack_dsprice">₹ 2499</p>
                                          </div>
                                          <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 9 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 10">
                                            <h5 class="fespack_cdprice">₹ 799</h5>
                                            <p class="fespack_dsprice">₹ 2999</p>
                                          </div>
                                          <div class="packprice" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 11 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 12">
                                            <h5 class="fespack_cdprice">₹ 899</h5>
                                            <p class="fespack_dsprice">₹ 3299</p>
                                          </div>
                                            <div class="packprice" *ngIf="pack?.productId == 1">
                                              <h5 class="fespack_cdprice">₹ {{pack?.packageSubscriptionDto?.amount}}</h5>
                                              <p class="fespack_dsprice">₹ {{pack?.packageSubscriptionDto?.amountPreDiscount}}</p>
                                            </div>
                                            <div class="packprice" *ngIf="pack?.productId == 6">
                                            <h5 class="fespack_cdprice">₹ 249</h5>
                                            <p class="fespack_dsprice">₹ 1699</p>
                                            </div>
                                        </div>
                                        <div class="plan-duration-list-area" *ngIf="microCourses">
                                          <!-- <h4 class="selct-duration-text" *ngIf="subscriptionbillingUtility?.packageValidityList?.length">Select a
                                            duration</h4> -->
                                          <div class="duration-list-box">
                                            <ul class="duration-list">
                              
                                              <li *ngFor="let package of  subscriptionbillingUtility.packageValidityList;let index = index">
                                                <label class="duration-radio-box">                                              
                                                  <input type="radio" name="subscription_duration" [value]="package?.numOfMonths"
                                                    [checked]="package?.numOfMonths == selectedMonths">
                                                  <div class="radio-chk-box" (click)="selectPackage(package)"></div>
                                                  <div class="content-wrap" (click)="selectPackage(package)">
                                                    <div class="lft-pnl">
                                                      <div class="month-title-area">
                                                        <h3>{{packageDeatails?.name}}</h3>
                                                        <h3>{{package?.numOfMonths}} Month<span *ngIf="package?.numOfMonths >1">s</span> Validity
                                                        </h3>
                                                        <!-- <h4>Valid till {{package?.validDate | date :'d MMM, y'}}</h4> -->
                                                      </div>
                                                    </div>
                                                    <div class="price-pnl">
                                                      <div class="pricrow">
                                                        <img src="assets/img/rupee-black-icon.svg" alt="" />
                                                        <div class="price">{{package?.amount| number:'1.0-0'}}</div>
                                                        <!-- <div class="fes_crdisline">{{package?.amountPreDiscount | number:'1.0-0'}}</div> -->
                                                      </div>
                                                      <!-- <div class="total-in" *ngIf="(package?.amount/package?.numOfMonths)!=package?.amount"><span
                                                          class="rupee">₹</span> {{package?.amount}} in Total</div> -->
                                                    </div>
                                                  </div>
                                                </label>
                                              </li>
                                            </ul>                                         
                                          </div>
                                        </div>
                                        <button type="button" class="fest_buypackbtn"(click)="BuyNow()">Buy Package</button>
                                        <div class="sharefiled">
                                          <h5 class="share_or">OR</h5>
                                          <h6 class="share_ask">Ask parents to buy now</h6>
                                          <div>
                                              <div class="number_field">
                                                  <input type="tel" class="number_input" value="{{sharedLink}}" id="cpycpn" #cpycpn  placeholder="">
                                                  <button type="button" *ngIf="!linkCopid" (click)="copycoupon(cpycpn)" class="copy_btn"><b>Copy</b></button>
                                                  <button type="button" *ngIf="linkCopid" (click)="copycoupon(cpycpn)" class="copy_btn"><b>Copied</b></button>
                                              </div>
                                          </div>
                                          <h6 class="share_ask">Share this page via</h6>
                                          <figure>
                                              <a href="https://api.whatsapp.com/send?phone=&text={{encodedUrl}}" data-action="share/whatsapp/share" class="festshremr"><img src="/assets/img/festival/festwhatsapp.png" alt="whatsapp" class="shareimg"></a>
                                              <span ><a (click)="copycoupon(cpycpn)"><img src="/assets/img/festival/festmsg.png" alt="msg" class="shareimg"></a></span>
                                          </figure>
                                      </div>
                                    </div>
                                </div>
                            </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="marketpr_show" *ngFor="let pack of filterdPackage">
          <div class="feslofrbottom">
            <div class="festpr_flexshow" *ngIf="!microCourses">
              <div class="festprbx1" *ngIf="pack?.productId == 3 && pack?.examName !='CBSE'">
                  <h2 class="festpr_mobshw">₹ 999</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE'  && selectedGrade == 6 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 7">
                <h2 class="festpr_mobshw">₹ 399</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 8">
                <h2 class="festpr_mobshw">₹ 699</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 9 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 10">
                <h2 class="festpr_mobshw">₹ 799</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 11 || pack?.productId == 3 && pack?.examName ==='CBSE' && selectedGrade == 12">
                <h2 class="festpr_mobshw">₹ 899</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 1">
                <h2 class="festpr_mobshw">₹{{pack?.packageSubscriptionDto?.amount}}</h2>
              </div>
              <div class="festprbx1" *ngIf="pack?.productId == 6">
                <h2 class="festpr_mobshw">₹249</h2>
              </div>
              <div class="festprbx2">
                  <h4 class="festpr_mobshwbtn" (click)="BuyNow()">Buy Package</h4>
              </div>
            </div>
            <div class="festpr_flexshow" *ngIf="microCourses">
              <div class="festprbx1">
                  <h2 class="festpr_mobshw">₹ {{microMobAmount}}</h2>
              </div>
              <div class="festprbx2">
                  <h4 class="festpr_mobshwbtn" (click)="BuyNow()">Buy Package</h4>
              </div>
            </div>
          </div>
      </div>
    </section>
    <!-- ========================= Hero area end========================= -->


    <!-- enrollnow form Modal starts-->
    <div class="modal fade bd-example-modal-lg" id="enrollnow" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <!-- <div class="nspopup">
                
                <button type="button" class="close nsbg-close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true" class="bg-close">&times;</span></button>
            </div> -->
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"><strong>Checkout</strong></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            <div class="modal-body">
              <form [formGroup]="enrollnowForm">
                <div class="form-style">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="labelpay">First Name</label>
                            <input type="text" class="UNFAPP-form-fld" formControlName="firstName" placeholder="First Name">
                            <div>
                              <label class="text-danger" *ngIf="enroll?.firstName?.touched && enroll?.firstName?.errors?.required">*Required</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="labelpay">Last Name</label>
                            <input type="text" class="UNFAPP-form-fld" formControlName="lastName" placeholder="Last Name">
                            <div>
                              <label class="text-danger" *ngIf="enroll?.lastName?.touched && enroll?.lastName?.errors?.required">*Required</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="labelpay">Email</label>
                            <input type="text" formControlName="email" class="UNFAPP-form-fld" placeholder="Email">
                            <div>
                              <label class="text-danger" *ngIf="enroll?.email?.touched && enroll?.email?.errors">
                                <ng-container *ngIf="enroll?.email?.errors?.required">*Required</ng-container>
                                <ng-container *ngIf="enroll?.email?.errors?.email">*Please Enter Valid Email</ng-container>                              
                              </label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="labelpay">State</label>
                            <select class="UNFAPP-form-fld" formControlName="state">
                              <option value="" selected disabled> Select State</option>
                              <option [value]="state?.abbreviation" *ngFor="let state of subscriptionbillingUtility.states">
                                {{ state?.name }}
                              </option>
                            </select>                    
                            <div>
                              <label class="text-danger" *ngIf="enroll?.state?.touched && enroll?.state?.errors">
                                <ng-container *ngIf="enroll?.state?.errors?.required">*Required</ng-container>                              
                              </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-8">
                        <label class="labelpay">Mobile number</label>
                        <div class="UNFAPP-form-fld-row">
                          <div
                            class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon"
                          >
                            <span class="UNFAPP-frmicon">
                              <img src="/assets/img//phone-icon.png" alt=""
                            /></span>
                            <div class="UNFAPP-phncuntry-fldgrp">
                              <select>
                                <option selected>+91</option>
                              </select>
                              <input
                                type="text"
                                placeholder="Phone Number"
                                formControlName="phone"
                                maxlength="10"
                                autocomplete="off"
                                onlyNumber
                              />
                            </div>
                          </div>
                          <label
                            class="text-danger"
                            *ngIf="enroll.phone.touched && enroll.phone.errors?.required"
                            >*Required</label
                          >
                          <mat-error
                            class="text-danger"
                            *ngIf="enroll.phone.errors?.minlength"
                          >
                            *Mobile number should be 10 digits
                          </mat-error>
                          <mat-error
                          class="text-danger"
                          *ngIf="enroll.phone.errors?.maxlength"
                        >
                          *Mobile number should be 10 digits
                        </mat-error>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <button
                          type="button"
                          class="enrollbtn-otp"
                          id="btn-otp"
                          *ngIf="!otpSent"
                          (click)="verifyPhone()"
                          [disabled]="!enrollnowForm.valid"
                        >
                          Send OTP
                        </button>
                        <label
                          *ngIf="otpSent && !resendotp"
                          class="enrolltxt-otp"
                          id="txt-resend"
                          >Resend OTP in {{ counter }} Sec</label
                        >
                        <button
                          type="button"
                          class="btn-resend"
                          *ngIf="resendotp"
                          (click)="verifyPhone()"
                        >
                          Resend OTP
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div *ngIf="otpSent" class="col-md-12" id="txt-edit">
                        <p class="bold">
                          Verify the OTP sent to +91 {{ enrollnowForm?.value.phone }}
                          <a (click)='editNum()' class="float-right d-none d-sm-block">EDIT</a>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div *ngIf="otpSent" class="col-md-12" id="txt-expire">
                        <p class="txt-expr">
                          OTP Expires in 15 mins
                          <!-- <a href="#" class="float-right d-block d-sm-none">EDIT</a> -->
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="margin">
                        <ng-otp-input
                          *ngIf="otpSent"
                          style="border-radius: 10px"
                          (onInputChange)="onOtpChange($event); otpError = false"
                          [config]="{ length: 4, allowNumbersOnly: true }"
                        ></ng-otp-input>
                      </div>
                      <div>
                        <button
                          *ngIf="otpSent && !isOtpVerified"
                          type="button"
                          class="btn-verify"
                          (click)="verifyOtp()"
                          [disabled]="!otpValid || otpError"
                        >
                          Verify
                        </button>
                        <button
                          *ngIf="isOtpVerified"
                          type="button"
                          class="btn-verify"
                          [disabled]="true"
                        >
                          OTP Verified
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="margin">
                        <label *ngIf="otpError" class="text-danger m-1">
                          OTP is incorrect or expired. Try again
                        </label>
                        <label
                          *ngIf="otpSent && !otpError && !isOtpVerified"
                          class="text-success m-1"
                        >
                          OTP sent
                        </label>
                        <label *ngIf="isOtpVerified" class="text-success m-1">
                          Your OTP for 
                          +91 {{ enrollnowForm?.value.phone }} is verified
                        </label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-lg-12 col-12">
                        <!-- <div class="UNFAPP-update-txt">
                          <label class="whtapp-custom-checkbox">
                            <input type="checkbox" formControlName="whatsappConsent" />
                            <span>Receive updates on Whatsapp</span></label>
                        </div> -->
                        <p class="UNFAPP-terms-text">
                          By signing up you agree to our
                          <a (click)="openTermsAndConditionsDialog()">T&C</a> and
                          <a (click)="openPrivacyPolicyDialog()">Privacy Policy</a>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <button
                          type="submit"
                          class="enrollpage-btn"
                          data-toggle="modal"
                          data-target="#cbseten"
                          [disabled]="!enrollnowForm.valid || !isOtpVerified"
                          (click)="Submit()"
                        >
                        Continue
                        </button>
                      </div>
                    </div>

                </div>
              </form>
            </div>

        </div>
    </div>
    </div>
    <!-- enrollnow form Modal ends-->

</div>

<app-course-footer></app-course-footer>
